<mat-icon>{{ icon }}</mat-icon>
<div class="text">{{title }}</div>

<ng-content></ng-content>
